import { useState, useEffect } from "react";
import { Phone, X, FileText } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const StickyCtaBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (dismissed || !visible) return null;

  return (
    <div
      className="hidden md:block fixed bottom-0 left-0 right-0 z-40 bg-[#1A1A1A] border-t-2 border-[#FF4D00] shadow-2xl"
      data-testid="sticky-cta-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <span className="font-heading text-sm font-bold text-white uppercase tracking-wider">
            Free Stump Grinding Estimates
          </span>
          <a
            href="tel:+15202007739,2"
            className="flex items-center gap-2 bg-[#FF4D00] hover:bg-[#e64400] text-white px-6 py-2.5 font-heading font-bold uppercase text-sm tracking-wider transition-colors"
            data-testid="sticky-call-btn"
            data-action="call"
          >
            <Phone className="w-4 h-4" />
            (520) 200-7739 Ext 2
          </a>
          {isHomePage ? (
            <a
              href="#quote"
              className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1A1A1A] px-6 py-2 font-heading font-bold uppercase text-sm tracking-wider transition-colors"
              data-testid="sticky-quote-btn"
            >
              <FileText className="w-4 h-4" />
              Get Free Quote
            </a>
          ) : (
            <Link
              to="/#quote"
              className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1A1A1A] px-6 py-2 font-heading font-bold uppercase text-sm tracking-wider transition-colors"
              data-testid="sticky-quote-btn"
            >
              <FileText className="w-4 h-4" />
              Get Free Quote
            </Link>
          )}
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-gray-500 hover:text-white transition-colors p-1"
          data-testid="sticky-dismiss-btn"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default StickyCtaBar;
